module.exports = __webpack_public_path__ + "static/media/premierOneLeftSeatSelected.b96ce402.svg";